import { action, payload } from 'ts-action'
import { IInvoice } from 'models/Invoice'
import { IError, IPayload } from 'models/Global'

export const GetInvoices = action('GetInvoices', payload<IPayload<IInvoice[]>>())
export const InvoicesError = action('InvoicesError', payload<IError>())
export const InvoicesFetching = action('InvoicesFetching', payload<boolean>())
export const ResetInvoicesReducer = action('ResetInvoicesReducer')
